/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ShipmentVoModel} from "./shipment-vo.model";
import {ServiceProviderVoModel} from '@well/domain';

export class ShipmentVendorTemplateVo extends ShipmentVoModel {

  serviceProviderVOList: ServiceProviderVoModel[] | undefined = undefined;
}
